import { Typography } from 'antd';
import React from 'react';

const {
    Text,
} = Typography;

export default function NotificationContent({notificationData}) {
    const {
        // content,
        // content_type,
        // created_at,
        // id,
        // is_read,
        subtitle,
        // title,
        // url,
    } = notificationData || {};

    return (
        <div className="list-item-content-container">
            <div className="list-item-content-subtitle">
                <Text type="secondary">
                    { subtitle }
                </Text>
            </div>
            {/* <div className="list-item-content-time-elapsed">
                    {Moment(created_at).fromNow()}
            </div> */}
        </div>
    );
}
